import React from 'react';

import { NormalizedButton } from 'lib/button';
import { getRem, removeOutline, transitionAnimation, visuallyHidden } from 'lib/core';
import { IconClose } from 'lib/icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { iconElementBasePositioning } from '../iconElementBasePositioning';

const REMOVE_ICON_SIZE = getRem(14);

const StyledIcon = styled(IconClose)`
  ${removeOutline};
  ${transitionAnimation('background-color, fill')};
  background-color: transparent;
  border-radius: ${({ theme }) => theme.size.borderRadius.full.value};
  fill: ${({ $isSelected, theme }) =>
    $isSelected ? theme.color.chip.selectedRemoveIcon.value : theme.color.chip.removeIcon.value};
  height: ${REMOVE_ICON_SIZE};
  padding: ${getRem('2px')};
  width: ${REMOVE_ICON_SIZE};
`;

const StyledRemoveButton = styled(NormalizedButton)`
  ${iconElementBasePositioning};
  cursor: pointer;
  display: inline-flex;
  margin: 0;
  padding: 0 ${getRem('6px')};
  right: 0;

  &:hover,
  &:focus,
  &:active {
    ${StyledIcon} {
      background-color: ${({ $isSelected, theme }) =>
        $isSelected ? theme.color.chip.selectedRemoveIcon.value : theme.color.chip.removeIcon.value};
      fill: ${({ theme }) => theme.color.additional.light.value};
    }
  }
`;

const StyledLabel = styled.span`
  ${visuallyHidden};
`;

const ChipRemoveButton = ({
  isSelected,
  label = 'Chip',
  onRemove = () => {},
  removeButtonLabel = 'Remove',
  ...other
}) => {
  return (
    <StyledRemoveButton type="button" onClick={onRemove} $isSelected={isSelected} {...other}>
      <StyledLabel>{`${removeButtonLabel} ${label}`}</StyledLabel>
      <StyledIcon $isSelected={isSelected} />
    </StyledRemoveButton>
  );
};

ChipRemoveButton.propTypes = {
  /** If true, renders input chip specific styles for remove chip button */
  isSelected: PropTypes.bool,
  /** Chip label */
  label: PropTypes.node,
  /** Callback function which is triggered on button click */
  onRemove: PropTypes.func,
  /** Text which is read for screen reader users, when remove button is focused */
  removeButtonLabel: PropTypes.node,
};

export { ChipRemoveButton };
